import { WindowOptions } from "./types";

// Partial<WindowOptions>ではなく、全てのキーを定義して型安全にする
export const defaultConfig: Required<WindowOptions> = {
	id: null,
	ifExists: "focus",
	title: "New Window",
	icon: null,
	x: "auto",
	y: "auto",
	width: 500,
	height: 400,
	minWidth: 200,
	minHeight: 150,
	virtualizable: true,
	animationOrigin: null,
	windowOptions: {
		resizableX: true,
		resizableY: true,
		movable: true,
		closable: true,
		minimizable: true,
		maximizable: true,
		maximizableOnDblClick: true,
		focus: true,
		alwaysOnTop: false,
		useGhostWindow: false,
		opacity: 1.0,
		modal: false,
	},
	content: {
		html: "",
		iframe: {
			src: "",
			srcdoc: "",
			allow: "",
			referrerPolicy: "",
			loading: "lazy",
			sandbox: "",
			loadWinLet: false,
		},
		template: "",
	},
	splitView: {
		direction: "horizontal",
		panes: [],
	},
	statusBar: {
		enabled: false,
		text: "",
		allowHTML: false,
	},
	search: {
		enabled: false,
		caseSensitive: false,
		showCaseSensitiveButton: true,
		showRegexButton: true,
		showWholeWordButton: true,
		targetSelector: "",
	},
	menu: [],
	menuStyle: "default",
	tabs: [],
	tabStyle: "default",
	tabOptions: {
		reorderable: false,
		closable: false,
		addable: false,
		detachable: false,
		mergeable: false,
		allowIncomingMerge: false,
		onAdd: undefined,
		onMergeAttempt: undefined,
	},
	taskbarOptions: {
		showIconOnly: true,
	},
	contextMenu: [],
	customControls: [],
	enableShortcuts: true,
	controlsPosition: "right",
	showLoadingIndicator: true,
	lazyLoad: false,
	disableMoveEvent: false,
	disableResizeEvent: false,
	virtualizationRestoreMode: "auto",
	showVirtualizationRefreshButton: true,
	onOpen: () => {},
	onClose: () => {},
	onFocus: () => {},
	onBlur: () => {},
	onResize: () => {},
	onMove: () => {},
	onReload: () => {},
	onBeforeClose: () => {},
	onMoveStart: () => {},
	onMoveEnd: () => {},
	onResizeStart: () => {},
	onResizeEnd: () => {},

	_isPopup: false,
	_parent: null,
	_taskbarItem: null,
};
